window.getSite = function() {
  let site = 'TEST'; // 默认测试环境
  if (window.env === 'prd' && window.Shopify && window.Shopify.shop) {
    const shop = window.Shopify.shop;
    let siteMap = {
      "segway-navimow-us.myshopify.com": 'US',
      "segway-navimow-store-eu.myshopify.com": 'EU',
      "navimow-de.myshopify.com": 'DE2',
      "navimow-fr2.myshopify.com": 'FR2',
      "navimow-se2.myshopify.com": 'SE',
      "navimow-it.myshopify.com":"IT",
      "navimow-ca.myshopify.com":"CA"
    };
    site = siteMap[shop] || 'TEST';
  }
  return site;
}